// theme
export default {
    getCurrentTheme(state) {
        return state.currentTheme
    }
}
